import React from 'react';
import { formatCurrency } from '../../../../../utils/currency';

const ItemVariation = ({ name, price, precision, isOnlyVariation, isLastVariation }) => {
  const variationStyle = { margin: 0 };

  return (
    <p style={variationStyle}>
      {formatCurrency(price, precision)} {!isOnlyVariation && name}
      {!isLastVariation ? <span style={{ margin: '0 0.25rem' }}>/</span> : ''}
    </p>
  );
};

export default ItemVariation;
